import React, { useEffect } from 'react';
import { useNotify } from 'react-admin';
import { ParseInventoryList } from '@/actions/ParseData';
import { noScroll, removeNoScroll } from '@/actions/Helper';
import {
  getInventory,
  delInventory,
  upInventory,
  importInventory,
  exportInventory,
  delContainer,
  getTableList,
  getOrdersInbox,
  getRequestsInbox,
  SaveApiResMessage,
} from '@/actions';
import { useParams } from 'react-router-dom';
import List from './List';
import styles from './styles';
import Pagination from '@/components/pagination';
import { useSelector } from 'react-redux';
import { ReactSVG } from 'react-svg';
import { Icons } from '@/assets';
import { usePusher } from '../../App';
import LoadingV2 from '@/components/Loading';

export default (props) => {
  const cls = styles();
  const notify = useNotify();
  const [state, setState] = React.useState({
    edit: null,
    appointment: null,
    appointmentSet: null,
    file: null,
  });
  const [pagination, setPagination] = React.useState({
    currentPage: 1,
    pages: [],
  });
  const { channels } = usePusher();
  const [tableTheadTitle, settableTheadTitle] = React.useState([]);
  const [ordersList, setOrdersList] = React.useState([]);
  const [ordersSeen, setOrdersSeen] = React.useState(0);
  const [requestsList, setRequestsList] = React.useState([]);
  const [requestsSeen, setRequestSeen] = React.useState(0);
  const params = useParams();
  const chatTypeParams = params.chatType || 'offer';

  const getInventoryTableHeadList = () => {
    setLoading(true);

    getTableList('inventoryTable')
      .then((res) => {
        if (res.data?.settings?.data) {
          settableTheadTitle(res.data?.settings?.data);
        } else {
          settableTheadTitle([
            // { label: '#', flex: 0.4, "show":  true  },
            { label: 'Size', flex: 0.6, show: true, object: 'size' },
            { label: 'SSL', flex: 0.7, show: true, object: 'ssl' },
            {
              label: 'Container #',
              flex: 0.7,
              show: true,
              object: 'name',
            },
            {
              label: 'Chassis #',
              flex: 0.9,
              show: true,
              object: 'chases',
            },
            {
              label: 'Gated Out',
              flex: 0.9,
              show: true,
              object: 'gated_out',
            },
            {
              label: 'Gated In',
              flex: 0.9,
              show: true,
              object: 'gated_in',
            },
            { label: 'Empty Location', flex: 0.7, show: true, object: 'loc' },
            {
              label: 'Return Apt',
              flex: 0.8,
              show: true,
              object: 'return_appointment',
            },
            {
              label: 'Return Location',
              flex: 0.7,
              show: true,
              object: 'return_terminals',
            },
            {
              label: 'Dual Terminal',
              flex: 0.7,
              show: true,
              object: 'return_dual_terminals',
            },
            { label: 'LFD', flex: 0.7, show: true, object: 'last_free_day' },
            {
              label: 'Est. PerDiem',
              flex: 0.7,
              show: true,
              object: 'est_per_diem',
            },
            // { label: 'Disputable Days', flex: 0.7 , "show":  true, object: '' },
            // { label: 'Disputable Amount', flex: 0.7 , "show":  true, object: '' },
            {
              label: 'Chassis Type',
              flex: 0.6,
              show: true,
              object: 'own_chases',
            },
            {
              label: 'Available Date',
              flex: 0.9,
              show: true,
              object: 'date',
            },
            {
              label: 'Last Update',
              flex: 0.9,
              show: true,
              object: 'added_date',
            },
            // { label: 'Action', flex: 1.3 , "show":  true, object: '' },
          ]);
        }
        setLoading(false);
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
        setLoading(false);
      });
  };

  React.useEffect(() => {
    getInventoryTableHeadList();
  }, []);

  const [loading, setLoading] = React.useState(true);
  const [DATA, setData] = React.useState([]);
  const [filter, setFilter] = React.useState({
    open: false,
    DATA: [],
  });

  const enable_empty_tracking = useSelector(
    (state) => state.reducer.user?.metas?.enable_empty_tracking?.value
  );
  const mptyTrackingEnable = enable_empty_tracking;

  const getInventoryList = () => {
    setLoading(true);
    getInventory({ page: pagination.currentPage })
      .then((res) => {
        let DATA = ParseInventoryList(res.data);
        let pages = [];
        for (let i = 1; i <= res.last_page; i++) {
          pages.push(i);
        }
        setPagination((prev) => {
          return {
            ...prev,
            pages,
          };
        });
        setData(DATA);
        setFilter({ open: false, DATA });
        setLoading(false);
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
        setLoading(false);
      });
  };
  const getOrdersInboxList = () => {
    setLoading(true);
    getOrdersInbox({ page: pagination.currentPage })
      .then((res) => {
        setOrdersList(res.orders);
        setOrdersSeen(res.unread_count);
        // console.log('orders', res);
        setLoading(false);
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
        setLoading(false);
      });
  };
  const getRequestsInboxList = () => {
    setLoading(true);
    getRequestsInbox({ page: pagination.currentPage })
      .then((res) => {
        setRequestsList(res.requests);
        setRequestSeen(res.unread_count);
        // console.log('requests', res);
        setLoading(false);
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
        setLoading(false);
      });
  };

  const getInventoryListNotLoading = () => {
    getInventory({ page: pagination.currentPage })
      .then((res) => {
        let DATA = ParseInventoryList(res.data);
        let pages = [];
        for (let i = 1; i <= res.last_page; i++) {
          pages.push(i);
        }
        setPagination((prev) => {
          return {
            ...prev,
            pages,
          };
        });
        setData(DATA);
        setFilter({ open: false, DATA });
        setLoading(false);
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
        setLoading(false);
      });
  };

  React.useEffect(() => {
    getInventoryList();
    getOrdersInboxList();
    getRequestsInboxList();
  }, [pagination.currentPage]);

  React.useEffect(() => {
    if (state.file) {
      setLoading(true);
      importInventory(state.file)
        .then((res) => {
          let DATA = ParseInventoryList(res);
          setData(DATA);
          setFilter((f) => ({ ...f, DATA }));
          setLoading(false);
        })
        .catch((err) => {
          // notify(err, 'warning');
          SaveApiResMessage({
            title: 'Error',
            message: err,
            mode: 'warning',
          });
          setData([]);
          setFilter((f) => ({ ...f, DATA: [] }));
          setLoading(false);
        });
    }
  }, [state.file, notify]);

  const Del = (id) =>
    delInventory(id)
      .then((msg) => {
        // notify(msg);
        SaveApiResMessage({
          title: msg?.data?.messageHeader,
          message: msg,
          mode: 'success',
        });
        getInventory()
          .then((res) => {
            let DATA = ParseInventoryList(res.data);
            setData(DATA);
            setFilter({ ...filter, DATA });
            setLoading(false);
          })
          .catch((err) => {
            // notify(err, 'warning');
            SaveApiResMessage({
              title: 'Error',
              message: err,
              mode: 'warning',
            });
          });
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
      });

  const DelContainer = (id) =>
    delContainer(id)
      .then((msg) => {
        // notify(msg);
        SaveApiResMessage({
          title: msg?.data?.messageHeader,
          message: msg,
          mode: 'success',
        });
        getInventory()
          .then((res) => {
            let DATA = ParseInventoryList(res.data);
            setData(DATA);
            setFilter({ ...filter, DATA });
            setLoading(false);
          })
          .catch((err) => {
            // notify(err, 'warning');
            SaveApiResMessage({
              title: 'Error',
              message: err,
              mode: 'warning',
            });
          });
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
      });

  const openPopUp = (item, containerId, gatedIn, gatedOut, container) => {
    noScroll();
    setState({
      ...state,
      edit: item,
      containerId: containerId,
      gatedIn: gatedIn,
      gatedOut: gatedOut,
      container,
    });
  };
  const openAppointment = (item, containerId, gatedIn, gatedOut, container) => {
    noScroll();
    setState({
      ...state,
      appointment: item,
      containerId: containerId,
      gatedIn: gatedIn,
      gatedOut: gatedOut,
      container,
    });
  };
  const openAppointmentSet = (
    item,
    containerId,
    gatedIn,
    gatedOut,
    container
  ) => {
    noScroll();
    setState({
      ...state,
      appointmentSet: item,
      containerId: containerId,
      gatedIn: gatedIn,
      gatedOut: gatedOut,
      container,
    });
  };

  useEffect(() => {
    if (channels?.privateChannel) {
      const handleNewOrder = () => {
        getOrdersInboxList();
        getRequestsInboxList();
      };
      channels.privateChannel.bind('NewOrder', handleNewOrder);
      channels.privateChannel.bind('OrderChange', handleNewOrder);
      channels.privateChannel.bind('OrderLastMessage', handleNewOrder);
      channels.privateChannel.bind('order_empty', handleNewOrder);

      return () => {
        channels.privateChannel.unbind('NewOrder', handleNewOrder);
        channels.privateChannel.unbind('OrderChange', handleNewOrder);
        channels.privateChannel.unbind('OrderLastMessage', handleNewOrder);
        channels.privateChannel.unbind('order_empty', handleNewOrder);
      };
    }
  }, [channels]);

  return (
    <div id="inventoryEmpty" className={cls.content}>
      <span className={cls.tableTopActions}>
        <ReactSVG src={Icons.directInbox} className={cls.directInboxIcon} />
        Your Inbox
      </span>
      {loading ? (
        <div className="mt-16">
          <LoadingV2 />
        </div>
      ) : (
        <List
          DATA={filter.DATA}
          chatTypeParams={chatTypeParams}
          DATAOrders={ordersList}
          DATARequests={requestsList}
          ordersSeen={ordersSeen}
          requestsSeen={requestsSeen}
          Del={Del}
          DelContainer={DelContainer}
          Edit={openPopUp}
          Appointment={openAppointment}
          openAppointmentSet={openAppointmentSet}
          getInventoryList={getInventoryList}
          getInventoryListNotLoading={getInventoryListNotLoading}
          currentPage={pagination.currentPage}
          mptyTrackingEnable={mptyTrackingEnable}
          tableTheadTitle={tableTheadTitle}
        />
      )}
      <Pagination pagination={pagination} setPagination={setPagination} />
    </div>
  );
};
